<tcc-simplePanel [size]="panalSize" [buttons]="['close']" (buttonClick)="close()">

    <div panel-header *ngIf="state === 'ready'">
        <div *ngIf="addOrEdit === 'add'">Add</div>
        <div *ngIf="addOrEdit === 'edit'">Edit {{currentOrgannization?.name}}</div>
    </div>

    <div panel-body *ngIf="state === 'ready'">
        <div class="container">
            <div style="width: 100%; text-align: center;">
                <p>
                    <i>
                        Currently only Lag Month can be updated. Lag Months support Management Fee Splits.
                    </i>
                </p>
                <p>
                    <i>
                        Adjustments can be made when the need arises.
                    </i>
                </p>
            </div>
            <div class="row">
                <div class="col-12" style="text-align: center;">
                    <h4>Organization</h4>
                </div>
            </div>

            <form [formGroup]="organizationFormGroup" (ngSubmit)="onSubmit()">

                <input type="number" formControlName="orgId" #orgId hidden>

                <label for="orgCode">Org Code: </label>
                <input type="text" formControlName="orgCode" [readonly]="true" name="orgCode" #orgCode>
                <br />
                <br />
                <label for="name">Name: </label>
                <input type="text" formControlName="name" [readonly]="true" name="name" #name>

                <label for="accountingMethodType">Accounting Method Type: </label>
                <input type="text" formControlName="accountingMethodType" name="accountingMethodType" [readonly]="true"
                    #accountingMethodType>

                <label for="metaJson">Meta Json: </label>
                <input type="text" formControlName="metaJson" #metaJson [readonly]="true" name="metaJson">

                <label for="propertyTypeName">Property Type Name: </label>
                <input type="text" formControlName="propertyTypeName" #propertyTypeName [readonly]="true" name="propertyTypeName">

                <label for="entrataPropertyId">Entrata Property ID: </label>
                <input type="text" formControlName="entrataPropertyId" #entrataPropertyId [readonly]="true" name="entrataPropertyId">

                <label for="lagMonth">Lag Month: </label>
                <input type="number" min="0" max="12" [ngClass]="{changed: isChanged('lagMonth')}"
                    formControlName="lagMonth" #lagMonth name="lagMonth">

                <div style="margin-top: 10px;">
                    <button type="submit" [disabled]="!organizationFormGroup.valid || 
                                                      !organizationFormGroup.dirty">Save</button>
                </div>
            </form>
        </div>
    </div>

</tcc-simplePanel>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>
